<template>
    <div id="biodigestor-asset-summary-card-widget-component">
        <WidgetWrapperComponent
            :title="$t('biodigestor_asset_summary_card_widget_component.equipment_information')"
            id-widget="biodigestor-asset-summary-card-widget"
        >
            <template v-slot:default>
                <div class="d-flex flex-column gap-3 rounded shadow shadow-gray-200 p-4 !text-skin-medium bg-white">
                    <div class="d-flex flex-column text-sm gap-1 basis-0">
                        <DisplayEntityInformationComponent
                            v-if="asset.internal_reference"
                            :data="asset.internal_reference"
                            :title="$t('internal_reference')"
                            icon="mdi-tag"
                        />

                        <DisplayEntityInformationComponent
                            v-if="asset.installation_date"
                            :data="asset.installation_date"
                            :title="$t('biodigestor_asset_summary_card_widget_component.installation_date')"
                            icon="mdi-calendar"
                        >
                            <template v-slot:data>
                                <ChipsLastStatement :date="asset.installation_date" :fallback_text="$t('unknown')" colorless />
                            </template>
                        </DisplayEntityInformationComponent>

                        <DisplayEntityInformationComponent
                            v-if="asset.client"
                            :data="asset.client?.client_space_name"
                            :title="$t('biodigestor_asset_summary_card_widget_component.associated_client')"
                            icon="mdi-account-group-outline"
                        />

                        <DisplayEntityInformationComponent
                            :data="assetModel ? $t(assetModel.name) : '-'"
                            :title="$t('biodigestor_asset_summary_card_widget_component.model')"
                            icon="mdi-trash-can-outline"
                        />

                        <DisplayEntityInformationComponent :data="asset.configuration[0].options" :title="$t('options')" icon="mdi-cog">
                            <template v-slot:data>
                                {{
                                    asset.configuration[0].options
                                        ? asset.configuration[0].options === 1
                                            ? $t('weighing')
                                            : $t('no_weighing')
                                        : '-'
                                }}
                            </template>
                        </DisplayEntityInformationComponent>

                        <DisplayEntityInformationComponent
                            :data="asset.configuration[0].maintenance_formula"
                            :title="$t('biodigestor_asset_summary_card_widget_component.maintenance_formula')"
                            icon="mdi-form-textbox"
                            class="mb-2"
                        />

                        <v-btn color="primary" elevation="0" rounded @click="$router.push('/documents')" class="w-fit">
                            <span class="white--text">Documentation</span>
                        </v-btn>
                    </div>
                </div>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import DisplayEntityInformationComponent from '@/components/global/DisplayEntityInformationComponent.vue'
import ChipsLastStatement from '@/components/global/containment/ChipsLastStatement.vue'
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'

export default {
    name: 'BiodigestorAssetSummaryCardWidgetComponent',
    components: { ChipsLastStatement, DisplayEntityInformationComponent, WidgetWrapperComponent },
    props: {
        asset: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            assetModel: null,
        }
    },
    mounted() {
        this.getAssetModel()
    },
    methods: {
        getAssetModel() {
            let idAssetModel = this.asset.configuration[0].id_asset_model

            if (idAssetModel) {
                this.assetModel = this.$store.getters['asset_module/asset_modules'].find(
                    (module) => module.id_module === this.asset.id_module
                )
            }
        },
    },
}
</script>
